import { render, staticRenderFns } from "./AddAndUpdateDocType.vue?vue&type=template&id=5fe2af2a&"
import script from "./AddAndUpdateDocType.vue?vue&type=script&lang=js&"
export * from "./AddAndUpdateDocType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports